import "./home.scss"

export default function Home() {
    return (
        <div className="home" id="home">
            <div className="nokHeadImgs">
                <img className = "headImg" src="assets/Nok01.png" alt="" />
                <img className = "headImg" src="assets/Nok02.png" alt="" />
                <img className = "headImg" src="assets/Nok03.png" alt="" />
                <img className = "headImg" src="assets/Nok04.png" alt="" />
                <img className = "headImg" src="assets/Nok05.png" alt="" />
                <img className = "headImg" src="assets/Nok06.png" alt="" />   
            </div>
            <div className="homeContainer">
                <img className="homeImg" src="assets/svggbnm.jpg" alt="" />
                <div className="homeContainerTitle">
                    <h1 className="head">NOKHEADS</h1>
                    <h1 className="artTitle">NOK SOME ART</h1>
                </div>
            </div>
        </div>
    )
}
